import { render, staticRenderFns } from "./DocumentsUpload.vue?vue&type=template&id=1e554538&scoped=true&"
import script from "./DocumentsUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentsUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsUpload.vue?vue&type=style&index=0&id=1e554538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e554538",
  null
  
)

export default component.exports